
import axios from 'axios';
axios.defaults.withCredentials = true

const ajax={
    post:function(url,data){
        console.log(url)
        return axios.post(url,{
            userId:window.sessionStorage.getItem('userId'),
            data:data
        })
    },
    get:function(url,data){
        return axios.get(url)
    }
}

export default ajax


// WEBPACK FOOTER //
// ./src/service/ajax.js